import React from 'react';

import ModalPrompt from '../../Web/Modal/ModalPrompt/ModalPrompt';
import { ModalManager } from '../../Web/Modal/hooks/useModalManager';

import modals from '../modals';

import DietaryOrCelebrationModalRender from './Render';
import { SheetProps, SelectedArgs } from './types';
import { useTheme } from '@ui-kitten/components';

type Props = SheetProps & {
  modalId: string;
};

const BookReservation = ({ modalId, payload }: Props) => {
  const theme = useTheme();

  const _onSelect = (d: SelectedArgs) => {
    ModalManager.hide(modals.DIETARY_OR_CELEBRATION, { payload: d });
  };

  return (
    <ModalPrompt
      id={modalId}
      closeButtonColor={theme['color-info-500']}
      title={payload.title}
      hasHeader
      hasHeaderLine
    >
      <DietaryOrCelebrationModalRender {...payload} onSelect={_onSelect} />
    </ModalPrompt>
  );
};

export default BookReservation;
